// Note: This file exports types related to events

// Event types from schema
export enum EventType {
  PAGE_VIEW = 'PAGE_VIEW',
  CLICK = 'CLICK',
  SCROLL = 'SCROLL',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
  SEARCH = 'SEARCH',
  FILTER = 'FILTER',
  REDIRECT = 'REDIRECT',
  SORT = 'SORT',
  SUBMIT_FORM = 'SUBMIT_FORM',
  DOWNLOAD = 'DOWNLOAD',
  UPLOAD = 'UPLOAD',
  JOB_VIEW = 'JOB_VIEW',
  JOB_APPLY = 'JOB_APPLY',
  LOGIN = 'LOGIN',
  LOGOUT = 'LOGOUT',
  SIGNUP = 'SIGNUP',
  PROFILE_UPDATE = 'PROFILE_UPDATE',
  ERROR = 'ERROR',
  FEATURE_TOGGLE = 'FEATURE_TOGGLE',
  PERFORMANCE_METRIC = 'PERFORMANCE_METRIC',
  CONVERSION = 'CONVERSION',
  NAVIGATION = 'NAVIGATION',
  DIALOG_OPEN = 'DIALOG_OPEN',
  DIALOG_CLOSE = 'DIALOG_CLOSE',
  FEEDBACK = 'FEEDBACK'
}

// Campaign types from schema
export enum CampaignType {
  VERIFICATION = 'VERIFICATION',
  INTRO = 'INTRO',
  DAILY = 'DAILY',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  ENGAGEMENT = 'ENGAGEMENT',
  REENGAGEMENT = 'REENGAGEMENT',
  INTERNAL_TEST = 'INTERNAL_TEST'
}

// Location data structure
export interface LocationData {
  country?: string;
  region?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  postal_code?: string;
}

// Base event structure that matches our Prisma model
export interface EventData {
  event_type: EventType;
  email?: string;
  session_id?: string;
  page_path?: string;
  referrer?: string;
  ip_address?: string;
  user_agent?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  url?: string;
  status?: string;
  type?: string;
  timestamp?: number;
  category?: string[];
  mail_id?: string;
  user_id?: string;
  campaign_type?: CampaignType;
  campaign_id?: number;
  campaign_batch_id?: number;
  campaign_segment_id?: number;
  device_type?: string;
  browser?: string;
  os?: string;
  location?: LocationData;
  element_id?: string;
  element_class?: string;
  element_text?: string;
  interaction_value?: number;
  event_details?: Record<string, any>;
  message_id?: string;
  payload?: string;
}

// GTM data structure
export interface GTMEventData {
  event: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  event_value?: number;
  [key: string]: any;
}

// Request payload type for the tracking API
export interface TrackEventRequest {
  events: EventData[] | EventData;
}

// Response type for the tracking API
export interface TrackEventResponse {
  success: boolean;
  count: number;
  errors?: string[];
  eventIds?: string[];
}

// Context data for automated tracking
export interface TrackingContext {
  userId?: string;
  email?: string;
  sessionId?: string;
  url?: string;
  referrer?: string;
  userAgent?: string;
} 